import state from "../state/main"

export default () => {
  // @ts-expect-error TS2339
  state.AJAX_REQUEST_CACHE = {}
}
